import { render, staticRenderFns } from "./SupplierPurchaseOrders.vue?vue&type=template&id=2d67feee&scoped=true"
import script from "./SupplierPurchaseOrders.vue?vue&type=script&lang=js"
export * from "./SupplierPurchaseOrders.vue?vue&type=script&lang=js"
import style0 from "./SupplierPurchaseOrders.vue?vue&type=style&index=0&id=2d67feee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67feee",
  null
  
)

export default component.exports